import React from 'react'
import { Alert, Button } from '@/components'
import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { useAppI18N } from '@/app'
import { GetOrgInvolvedModal } from '../modals'

export const GetOrganisationInvolved = React.memo(() => {
  const { t } = useAppI18N()

  // const modalsContext = ModalManager.useModalContext()
  // const { data: profile } = APIClient.Session.useProfile()

  const getOrganisationInvolved = () => {
    // NOTE: The client might opt for this again in the future
    // APIClient.Session.openComposer({
    //   to: 'support@kiteup.co',
    //   subject: t('emailComposition.getOrganisationInvolved.subject'),
    //   message: t('emailComposition.getOrganisationInvolved.message'),
    //   body: t('emailComposition.getOrganisationInvolved.body'),
    // })

    // if (hasUnknownOrg) {
    //   modalsContext.toggleModal('unknown_org_modal')
    //   return
    // }

    // if (!profile.can_get_organization_involved) {
    //   return Alert.info({
    //     title: t('modals.getOrganisationInvolved.notAvailable.title'),
    //     body: t('modals.getOrganisationInvolved.notAvailable.description'),
    //   })
    // }

    AppStatus.setModal('getOrgInvolved')
  }

  return (
    <>
      <Button
        variants={['fullWidth', 'outline']}
        text={t('learn.components.doneModal.organisationButton')}
        debugName={`Modal done organisation`}
        onPress={getOrganisationInvolved}
      />
      {/* <GetOrgInvolvedModal onDone={onContinue} /> */}
    </>
  )
})
